import React, { Component } from 'react';
import { connect } from 'react-redux';

import styles from './_styles/ImportPending.module.scss';

const allActionCreators = Object.assign({});

export class ImportPending extends Component {

	render() {
		return <div className={styles.ImportPending}>
			<div className={styles.pendingWrapper}>
				<div className={styles.pendingCopy}>
					{`Import in progress${parseFloat(this.props.progress) ? `: ${Math.round(100*parseFloat(this.props.progress))}%` : ''}`}
				</div>
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(ImportPending);